import { trainingProducts } from '../data/trainingProducts'
import { Teacher } from '../types/teacher'

export function teacherFullName(teacher?: Teacher): string {
  return teacher ? `${teacher.firstName} ${teacher.lastName}` : 'Docente rimosso'
}

// Macrocategorie derived from the courses the teacher is enabled for
export function teacherCategories(teacher: Teacher): string[] {
  const categories = teacher.productCodes
    .map((code) => trainingProducts.find((p) => p.code === code)?.category)
    .filter((c): c is string => Boolean(c))
  return Array.from(new Set(categories))
}

// A teacher can be assigned to a course only if enabled for its product
export function isTeacherEnabled(teacher: Teacher, productCode?: string): boolean {
  return !productCode || teacher.productCodes.includes(productCode)
}

export function formatTimestamp(iso: string): string {
  const date = new Date(iso)
  const day = date.toLocaleDateString('it-IT')
  const time = date.toLocaleTimeString('it-IT', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return `${day} alle ${time}`
}
